import { connect } from 'redux-bundler-react';
import Icon from '@components/icon/Icon';
import { mdiNoteEdit, mdiFileCheckOutline } from '@mdi/js';

import { RequestStatus, RequestStatusStyles } from '@src/utils/enums';

import './FormStatus.scss';

const FormStatus = connect('selectRequestStatus', ({ requestStatus }) => {
  const icon = requestStatus === RequestStatus.Draft ? mdiNoteEdit : mdiFileCheckOutline;
  const statusStyles = RequestStatusStyles[requestStatus] || 'draft';

  return (
    <div className={`form-status ${statusStyles}`}>
      <Icon focusable={false} className='form-status-icon' path={icon} size={0.9} /> {requestStatus}
    </div>
  );
});

export default FormStatus;
